import MockAdapter from 'axios-mock-adapter';
import {api} from './api';
import {
    accountArray,
    fetchDepotFromAccountIdData,
    transactionArray
} from './accountActionsDEVDataTest';
import {notificationsArray} from './notificationActionsDEVDataTest';
import {
    allBanks,
    bankConnections,
    failureBankAddingState,
    initialBanks,
    successBankAddingState
} from './bankActionsDEVData';
import {categoryArray} from './categoryActionsDEVData';
import {contractValidationData, defaultOffer} from './offerActionsData';
import {companiesData} from './logoActionsDEVData';
import {
    allRecurringpaymentsData,
    singleEnergyRecurringPayment,
    singleRecurringPayment
} from './recurringpaymentActionsDEVData';
import {
    allInsuranceCompanies,
    fetchAllInsuranceProductsData,
    carInsuranceSubmitResponse,
    testPolicies,
    testCarInsuranceProposal,
    testVehicleHolder,
    carInsuranceResultResponse
} from './productActionsDEVData';
import {aboalarmLink} from '../../__data__/recurringpayments.data';

export const mock = new MockAdapter(api, {delayResponse: 2000});

/* *** CONTRACTS *** */
mock.onGet('/contracts/').reply(200, testPolicies);
mock.onPost('/contracts').reply(200, {
    companyId: testPolicies[0].companyId,
    id: testPolicies[0].id,
    insuranceType: 'Neu hinzugefügt'
});
mock.onGet(/\/contracts\/\S+\/cancellation\/iframe/).reply(200, aboalarmLink);
mock.onPost(/\/contracts\/\S+\/cancellation/).reply(200, '');
mock.onPatch(/\/contract\/\S+/).reply(200, {
    insuranceType: 'ROLLER-KFZ',
    id: 10,
    logoPath: '24.svg',
    status: 'pending',
    insuranceNumber: 23422235937238,
    companyId: 8712,
    amount: 10,
    paymentInterval: 'MONTHLY'
});

/* *** ACCOUNTS *** */
mock.onGet('/accounts/').reply(config => {
    const header = config.headers;
    if (typeof header?.params?.ids !== 'undefined') {
        return [
            200,
            accountArray.filter(account =>
                header.params.ids.includes(account.id)
            )
        ];
    } else {
        return [200, accountArray];
    }
});

/* *** TRANSACTIONS *** */
mock.onGet('/transactions/').reply(200, transactionArray);

mock.onGet(/\/transactions\?accountIds=\S+/).reply(config => {
    return [
        200,
        transactionArray.filter(transaction =>
            config.url?.includes(String(transaction.accountId))
        )
    ];
});
mock.onGet(/\/accounts\/\S+\/securities/).reply(
    200,
    fetchDepotFromAccountIdData
);
mock.onPut(/\/accounts\/\S+\/visible/).reply(200, '');
mock.onDelete(/\/accounts\/\S+\/visible/).reply(200, '');
mock.onGet(/\/accounts\/\S+\/update/).reply(200, null);

/* *** BANKS *** */
mock.onGet('/banks?initialView=true').reply(200, initialBanks);
mock.onGet('/banks').reply(200, allBanks);
mock.onGet(/\/banks\/\S+\/receiveBindingLocation/).reply(
    200,
    'https://sandbox.finapi.io/webForm/oljKzzW04Q31BcaS3nrqRJIcR67oOHacN961ZNdgVb5YyeySaa_JrDMz0GAKvIihsS9ptNL70Tv2tmVLNMO_uQ9En_2UqqzPOzNyYQhq3wSuQh1EGOEAm6ijsiAOzCvz'
);
mock.onGet(/\/dialog\/add\/1/).reply(200, failureBankAddingState);
mock.onGet(/\/dialog\/add\/\S+/).reply(200, successBankAddingState);

/* *** BANK CONNECTIONS *** */
mock.onGet('/bankconnections').reply(200, bankConnections);
mock.onGet(/\/bankconnections\/\S+\/update/).reply(200, null);
mock.onGet(/\/bankconnections\/\S+/).reply(200, bankConnections[0]);

/* *** CATEGORIES *** */
mock.onGet('/categories').reply(200, categoryArray());

/* *** RECURRING PAYMENTS *** */
mock.onGet('/recurringpayments').reply(200, allRecurringpaymentsData);
mock.onPost('/recurringpayments').reply(config => {
    const body = JSON.parse(config.data);
    if (body.categoryId === 4350) {
        return [
            200,
            {
                ...singleEnergyRecurringPayment,
                ...body,
                lastAmount: body.amount
            }
        ];
    } else {
        return [
            200,
            {
                ...singleRecurringPayment,
                ...body,
                lastAmount: body.amount
            }
        ];
    }
});
mock.onPatch(/\/recurringpayments\/\S+/).reply(config => {
    const body = JSON.parse(config.data);
    const recurringPaymentId = Number(config?.url?.split('/')[2] ?? -1);
    if (typeof body.meterNumber !== 'undefined') {
        return [
            200,
            {
                ...singleRecurringPayment,
                recurringPaymentId: recurringPaymentId,
                changeData: {
                    changeState: 'onGoing',
                    startDate: new Date().toISOString(),
                    providerName: 'new provider',
                    yearlyCosts: 872.92,
                    estimatedYearlySavings: 242.24
                }
            }
        ];
    }
    return [
        200,
        {
            ...singleRecurringPayment,
            isArchived: body.isArchived,
            categoryId: body.categoryId,
            paymentInterval: body.paymentInterval
        }
    ];
});
mock.onGet(/\/recurringpayments\/\S+\/offers/).reply(200, defaultOffer);
mock.onPost(/\/recurringpayments\/\S+\/offers/).reply(200, defaultOffer);
mock.onPost(/\/recurringpayments\/\S+\/change/).reply(config => {
    const body = JSON.parse(config.data);
    const recurringPaymentId = Number(config?.url?.split('/')[2] ?? -1);
    if (
        typeof body.meterNumber === 'undefined' ||
        body.meterNumber.length === 0
    ) {
        return [
            200,
            {
                ...singleEnergyRecurringPayment,
                recurringPaymentId: recurringPaymentId,
                changeData: {changeState: 'meterNumberMissing'}
            }
        ];
    } else {
        return [
            200,
            {
                ...singleEnergyRecurringPayment,
                recurringPaymentId: recurringPaymentId,
                changeData: {
                    changeState: 'onGoing',
                    startDate: new Date().toISOString(),
                    providerName: 'new provider',
                    yearlyCosts: 872.92,
                    estimatedYearlySavings: 242.24
                }
            }
        ];
    }
});
mock.onGet(/\/recurringpayments\/\S+\/change/).reply(
    200,
    contractValidationData
);

/* *** COMPANIES *** */
mock.onGet('/companies').reply(200, [
    ...companiesData,
    ...allInsuranceCompanies
]);

/* *** PRODUCTS *** */
mock.onGet('/products').reply(200, fetchAllInsuranceProductsData);
mock.onGet(/\/products\/\S+\/getLink/).reply(
    200,
    'https://sxr14900.preview.sachversicherung.geld.de'
);
mock.onPost(/\/products\/\S+\/confirm/).reply(200, '');
mock.onGet(/\/products\/\S+\/files\/\S+/).reply(
    200,
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZ4AAAB4CAYAAADCFpQkAAAPwklEQVR4Xu2dWwg3RRmHf57ykIfKzMhKLeomS6gwsqgoKjDKTgRddNGNddOJuuhCCCovjCLSCwtvIrqoQCIwogOdNcouTC/tYEqmpmlJHlIrXtmB+bbd/c/uzmlnnz98ZN83M+87z/vO/HZmZ3ePEj8IQAACEIBARgJHZbSFKQhAAAIQgIAQHpIAAhCAAASyEkB4suLGGAQgAAEIIDzkAAQgAAEIZCWA8GTFjTEIQAACEEB4yAEIQAACEMhKAOHJihtjEIAABCCA8JADEIAABCCQlQDCkxU3xiAAAQhAAOEhByAAAQhAICsBhCcrboxBAAIQgADCQw5AAAIQgEBWAghPVtwYgwAEIAABhIccgAAEIACBrAQQnqy4MQYBCEAAAggPOQABCEAAAlkJIDxZcWMMAhCAAAQQHnIAAhCAAASyEkB4suLGGAQgAAEIIDzkAAQgAAEIZCWA8GTFjTEIQAACEEB4yAEIQAACEMhKAOHJihtjEIAABCCA8JADEIAABCCQlQDCkxU3xiAAAQhAAOEhByAAAQhAICsBhCcrboxBAAIQgADCQw5AAAIQgEBWAghPVtwYgwAEIAABhIccqI3AcyTdXptT+AMBCMQjgPDEY0lL6wj8R9JYPpKn69hSGwJVEWBAVxWOpp05T9Lvuh5a3s3JvcclHds0HToHgR0RmDP4d4SFri4k8LCk4zxRWZJftvK5WtIlK9tZ2AWqQQACqQksmRhS+0T7eQmcIulCSS+S9HxJZ0l6a4ALc1ctQ03+V5L9uU7SGyU90hXyt91Y7QQEgyIQ2BIBhCddtPyrf5tc57KeWz5dT5a3bP22nwnJxyRdGdCULzpW/+iAOhSBAAQ2RKCFyS0Fbjdhpmi7tTYdq99KumBl5xCdlQCpDoEtEEB4hqNUk/Cs8eU+SbbyerD7c7+kuyTdIekWSTd121w24dfwc31lpVNDNPABAokIIDxxhcdNnNdKenu3xZQodM016692tp6XdjDiK12EzpV0a3PRokMQWEFg6wN8RdepWhGB1rbYbNvxZR3fkyQ9VBFrXIFAcQIIT/EQ7N6BxyQd01GIscVmp+DcgYRS+W1bmqd1fSrlw+4TCwD1EmBQ1BubvXjm38OKkY81bNk96j3wGqNPe8kF+rkTAgyKnQS64m7GPlBQg/DU4EPFIce1vRNAePaeAWX772+zPSDp1Aju1DDp1+BDBJQ0AYE0BBCeNFxp9TCB/jHxWLlYw6Qfe/vwME1KQGBDBGIN9g11GVcrIOBPzPbfJhaxXgJak/DEOCxRQbhwAQJxCSA8cXnSWhiB2Pd1fKsIT1gMKAWBYgQQnmLod214L8JjLz09YdeRpvMQGCCA8JAWuQncK+lpnVFbnbhneGL5UdOK5zZJZ8fqGO1AoBUCCE8rkdxGP+6RdLrnaor8q0l4LpN06TZCg5cQyEcgxcDP5z2WtkbAF4UUqx3jUVp4Pijpqi4wJ3Yvad1anPAXAkkJIDxJ8dJ4j0COY8alhedGSed3/WZ8MQQgwD0ecqAwgT0Ijz0IezLCUzjTMF81Aa7Iqg5Pc87tQXj8tzEwvppLYToUgwADIwZF2gglsAfhKb3VFxoLykGgGAGEpxj6XRpGeHYZdjoNgSMJIDxkRE4CexCelA/H5owVtiCQjADCkwwtDQ8QQHhICwhAQAgPSZCTwJ6EJ9VzSjnjhS0IJCGA8CTBSqMjBPYkPP/0Pn9NQqQlYHnFm8DTMo7aOsITFSeNHSCQ48RXDhtT3XTi+j1JF5ERyQn0P7FxdHKLGFhNAOFZjZAGZhJIffO9pPC8UtL1HQ/G1szEWFgc4VkIrmQ1BkdJ+vu0nXq7raTw3CzpPIQna2IjPFlxxzGG8MThSCvhBFoWnoe87+8wtsJzYk1JhGcNvUJ1GRyFwO/YbMvCU3K1tceU8nlb/zlgsJEsQHg2EqiG3ER4Ggpm4a4gPIUDsNQ8wrOUHPWWEmhZeFIfnFjKvNV6fi6x4tlQlBGeDQWrEVcRnkYCWUE3EJ4KgrDEBYRnCTXqrCGwB+F5VNKT1kCibhABhCcIU32FEJ76YtK6R3sQnke8022tx7Nk/xCekvRX2EZ4VsCj6iICCM8ibFQaIIDwbDQtEJ6NBm7DbqcWnpI3+J1tVjx5EhThycM5uhWEJzpSGjxAAOEhRWIRQHhikczcDsKTGTjmnnjIz/1S5J9r/xeSXpOZt7N9h6SzMtveo7k5wnO2pIslnS/pSkk37hFYLX1OMfBr6Rt+1EkgpfA8Lsm9nbhEbru+XS3pkjrxN+XVlPBcI+nfkl4v6QxJlhvHdr3/s6RzmiKxsc6UGJwbQ9SsuzYQ5/wsV/oD3eqP/f1Y2/5r6+3J87Hf3HadLy6nc+f2hyRd0XUm1PZTJN0/JwiUPYLAkPCMvTbH/v4fkuxzFZ9jxVM2k0IHSFkvsZ6CQP91Iyls1N6mm7j6Iuf+f/9/+/3xx4+11R9P9nf2x1g/1v33vyTdK8neZP2urkErc0ztsCrw70fdCsZdZEy5ZEwflnS3pKskXV6B/7gw88oMYO0R8Lel2utd/T2yk2/He25yETgds6HV9lAN2177jKTP1p8C+/WQZN9v7Ev0POX9HeuPv4rzVzMl+ups+ise8+9BSfdI+no3QbpyOcei4zQWD3/15h9PL7Eq+5KkDw8E0D4tfmrv78e22UrGH9sDBHImOwHYNwGbcE/sENh3a05KgKPkZwnctpqNqdBxlVqIhxCv3WL1b9InCOERTd4nye6D+SLu3yOcc6otta+0P4NA6ACZ0SRFITBIIIco5LAxFl43CV4q6bLAHMgtPGtFp98t89+2tk4I7O+cYva+O3cKzerZfbGnD6xw/L9ixTOHcMGyCE9B+Dsz7W/Z+FetMTHksHFIeOaMqZzC0xedOX5an+1GvX9PyudgbcfchvuypA94BsZ8ZcUTc/RkbGtu8mV0DVONEUgtCn+UdG7H7AZJF2Tkd6ekMzt7c8bUlPBMrU7mrjT6ojHHxz5Ga8u9ebt/qi/WBUXoyhXhyZjkMU2tScCYftBW+wTcJPEbSa9I0N2SD48uXbmM1Qs9cRg6fkMn8iVh6R/oiCE+oRcpCM+SiFVQJzRxK3AVFzZMwJ5dcYcJUuVcDcJj9zvGtqOGwtcXnpskndc7nDB0jNgxDN3iSn3CzxefGC9Idf4e6p/Phvs7G5ogUk0CG0KAqxkIpLzidu7nsHHo/s5XJb1/Bs++8Mzpg6trD6YeN2Fz6WpsRjeeKBpTBEKEZ+09q7n9o3xEAghPRJg0NUogdOtkDcJcE2zfx6X3d/qTtf/2hJCr91CmubiYAPoHDEL6cEjI/Tb67ffrMpetGT2Z6xKszMB3aM6/Mr1e0qsSMQidiGObn7NK6dv2ReEWSS/oChzaYrJi/QMD10l69UDncglPzJVnP5Yhx8CZy2JndsL2CFZCuDT9f1swKfPNTVYx7jHMCV3IttChK/ulV+8hN/ZzC4+/kgsR0CE2vvD0c8Z/gLVE3+bkBmVHCKScCIAOAX9iSLnasS0e24qxnx1isDcj5Pq5PtrLKN2R6lDbQwcHbOXzwtAGJP3SW0UOfQeof+8l1QOfvstLV5/uqPbQvDS0dYfwzEiUmooiPDVFox1fftb7CNvSK99QIrdKsg992S93TrvJ7xOSvhDqcFeuLzy3S3ruzDZccddWv/9D21RW1v7EfOhzqfDYCmbqNUPm55hYIjwLk6V0tdyDtHR/sZ+egL288RTPTGrRMVOlJqDvSrpoheD1hWfNeHQCM7TqOXSPJKYQ+feehlYpIc8oWT3HYopJqbinH0WNW1iT6I2joXsLCPQnlQcG3iC8oNmDVZZu7Rxs+EAB/yWWS8ZSfxtszcOXf5H0rG7Lcep4dejE73fdP3E3hWRsiyxkJdpf2Tg2P5b0hhGjCM/aDC5Uf8lgKeQqZisn0L+q/rmk12bw+eOSPr9i1bHGxbUPrfoTZ4y3PrvVhm09utcHTfXP7ouZ2JWYB6a20Pqr2KGVU8mV7pqcoW6hhAN8ewRKPsz3NknfKSQ8a6+419YfyqSxez0hWZdSiCxH7I3ToW+ytk+Cn+Y5zeGCkAhupEyJK52NoMHNQAIhR3oDm1pU7OWS7KWgIds5iwxMVHKT/KG3B4w1UYPwHLq5PyVu/r+lOqzgM+qvolPwi50jtDdAAOEhLdYQKC065vuzJdlpsJLC83vv4c85PFNMnP0DC3P86Zf127JY+9/HWdPu3Lpj9/BS8JvrG+UXEEB4FkCjyhMEahAd88O+ampfN80tPO+T9LXO7ksk3bwgL9zWVsxJ/T2SvrnAl/5Bh1RHrRe4dkSu+XMWwrOEZgV1EJ4KgrBBF2oRHYduzX2Npfj/JOmcAoJ3yF97DsgOF4T8zP/bQgoWLjP2WiKEp3BglppHeJaS22e970t6k9f1sdNGuemUEB57Nc/QB9Fy930P9nzh8Z8LQ3g2Gn2EZ6OBK+B2/+RaLaJjKEoID5Ne3iQceuaJGOSNQTRrCE80lM029HdJT+31bukprlSQSgpPbSxSMS7d7q97nzO3CyH/gVvmstIRmmGfYM2AtcOiNa9y/HCUFJ6/dm8M2GF6FOny2Lvn1rz1oUhH9mwU4dlz9Mf7PjS4fyDpzZXiKik8V0j6SKVcWnXLf2NETVu+rfKO3i+EJzrSTTe41avJ3MJzjaR3dpFmDG065XG+BAEGTQnqddn8m6TTB16fZJP5Dyte5ZTcaiv5GYa6sgdvILCAAMKzAFojVcZelb+1rQsnAvYQ6ZMzxeYPkp7HiicTbcw0RwDhaS6kkx3ynz3pF9ya4Dj/7Wuj9uLJT0q6PFM4EZ5MoDHTJgGEp824+r36tqSLR95EbmJzr6QzNowh9/0dQ4XwbDhhcL08AYSnfAxSeTD11Un7lPDxqQxnbhfhyQwccxBYSwDhWUuwrvotbqUdIvy6rsBPDxWM+O+seCLCpKn9EUB4xmNuE9pPvH+u9R7InZKeMbGVZh9Je8f+UjtpjxGepHhpvHUCCM90hD8q6YsDRb4h6b0Fk2Pqvo25dZekZxb0r3XTCE/rEaZ/SQkgPOF4b5L04oHi93XvjLKPZJ0c3tyskt+S9O4DnyqvdUU2q6MbKXy3dyCDMbSRoOFmPQQYNPNjMXUfxbVmN+/7bKdYD/2bvXvqUHxMbNhKmx/DtTVcDviv6F/bJvUhsBsChya23YBY0FH3/MiCqquqsLJZhS9KZXdi0ATIniHiBwEIzCCA8MyAFVD0Bkkv7b2uPaDaZBGEZi3B+PXdEW7bcjszfvO0CIG2CSA8bceX3qUh4ITnV5IuTGOCViHQLgGEp93Y0rN0BJzwfErSp9OZoWUItEkA4WkzrvQqHYG3SLq2a97e/mAHSfhBAAIzCPwPGwKYl8/e2HIAAAAASUVORK5CYII='
);

mock.onGet('/mydata').reply(200, testVehicleHolder);
mock.onPost('/products/car/proposal').reply(200, testCarInsuranceProposal);
mock.onPost('/products/car/request').reply(200, carInsuranceSubmitResponse);
mock.onPost('/products/car/switch').reply(200, {});
mock.onGet(/\/contract\/\S+/).reply(200, carInsuranceResultResponse);

/* *** NOTIFICATIONS *** */
mock.onGet('/notifications').reply(200, notificationsArray);
mock.onDelete(/\/notifications\/\S+/).reply(200, '');
